// React
import React, { useState, useContext } from "react";
// React
// CSS
import styles from "./Home.module.css";
// CSS
// Components
import HomePageSlides from "./HomePageSlides/HomePageSlides";
import UserStatus from "./UserStatus/UserStatus";
import HelperHeader from "../../Utils/HelperHeader/HelperHeader";
import UserLessons from "../../Components/UserLessons/UserLessons";
import AddToHomeScreen from "../../Utils/AddToHomeScreen/AddToHomeScreen";
import { UserTokenContext } from "../../Contexts/userToken";
// Components

const Home = () => {
  const [canShowAddToHomeScreen, setCanShowAddToLomeScreen] = useState<boolean>(
    String(localStorage.getItem("amoozesh")) === "true" ? false : true
  );
  const [isModalInScreen, setIsModalInScreen] = useState<boolean>(true);

  const userToken = useContext(UserTokenContext);

  return (
    <div className={`${styles.homeContainer} p-4 pt-2 overflow-y-scroll`}>
      {userToken !== "init" &&
      canShowAddToHomeScreen &&
      isModalInScreen &&
      !window.matchMedia("(display-mode: standalone)").matches ? (
        <AddToHomeScreen
          setCanShowAddToLomeScreen={setCanShowAddToLomeScreen}
          setIsModalInScreen={setIsModalInScreen}
        />
      ) : null}
      <UserStatus />
      <HomePageSlides />
      <HelperHeader absoluteText="دروس ارائه شده" className="mt-10  w-full" />
      <UserLessons />
    </div>
  );
};

export default Home;
